import { useState, useEffect } from 'react';

export default function useForecastPubTime(stateConfig) {
  const [forecastPubTime, setForecastPubTime] = useState();
  const [minForecastPubTime, setMinForecastPubTime] = useState();

  const handleForecastPubTimeChange = (newValue) => {
    setForecastPubTime(newValue);
  };

  useEffect(() => {
    if (stateConfig) {
      const dt = new Date(stateConfig['minPubTime']);
      setMinForecastPubTime(dt);
    }
  }, [stateConfig]);

  return { minForecastPubTime, forecastPubTime, handleForecastPubTimeChange };
}
